export const darkTheme = {
  bg: "#121212",
  bgLight: "#1e1e1e",
  primary: "#8bc34a",
  text_primary: "#e0e0e0",
  text_secondary: "#888888",
  card: "#1e1e1e",
  card_light: "#252526",
  button: "#8bc34a",
  white: "#FFFFFF",
  black: "#000000",
};

export const lightTheme = {
  bg: "#FFFFFF",
  bgLight: "#f0f0f0",
  primary: "#be1adb",
  text_primary: "#111111",
  text_secondary: "#48494a",
  card: "#FFFFFF",
  button: "#5c5b5b",
};
